export default {"src":"/_next/static/media/progression.0caa2047.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};